export enum MaritalStatus {
  Married = 'Married',
  Single = 'Single',
  Cohabiting = 'Cohabiting',
  Divorced = 'Divorced',
  Seperated = 'Seperated',
  Widowed = 'Widowed',
}
